class r {
  constructor() {
    this.decimalSeparator = ",";
  }
  zipcode(a) {
    return !!a.match(/^([A-HJ-NP-Z])?[1-9][0-9]{3}([A-Z]{3})?$/i);
  }
}
export {
  r as default
};
